import { Component, OnInit } from '@angular/core';
import { DashboardSectionStatus } from '../dashboard.component';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
//import countries from '../../assets/data/countries.json';
import plantree from '../../../assets/data/plan-tree.json';

@Component({
  selector: 'app-my-dashboard-tab1',
  templateUrl: './my-dashboard-tab1.component.html',
  styleUrls: ['./my-dashboard-tab1.component.scss']
})
export class MyDashboardTab1Component implements OnInit {
  SectionTitle = "My Assets"
  SectionStatus = DashboardSectionStatus
  AssetsInfo = 'John, why no take a few minutes to review the items value listed in your plan?'

  AssetsNumbers = [
    {
      circle: 'upToDate',
      number: 1,
      SectionStatus: DashboardSectionStatus[0]
    },
    {
      circle: 'toReview',
      number: 8,
      SectionStatus: DashboardSectionStatus[1]
    },
    {
      circle: 'toAdd',
      number: 10,
      SectionStatus: DashboardSectionStatus[2]
    },
  ]

  reviewStatusPerSection = [];
  constructor(private zenPlansData:ZenplansTestDataProviderService) { 
  }

  async ngOnInit() {
    let sectionStatus = await this.zenPlansData.getPlanCategoryStatus("my assets");
    this.AssetsNumbers[0].number= sectionStatus["upToDates"];
    this.AssetsNumbers[1].number= sectionStatus["forReviews"];
    this.AssetsNumbers[2].number= sectionStatus["missing"];
    this.reviewStatusPerSection = sectionStatus["reviewCodes"];
  }

  async getSectionStatus(){

  }

}
